__turbopack_context__.v({
  "root": "SleepScoreModal-module__rXXTea__root",
});
